<style scoped lang="scss">
.phone_index{
  overflow: auto;
  display: none;
}
.phone{
  overflow: auto;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (min-width: 300px) and (max-width:400px),
screen and (max-width: 640px) and (min-width: 600px) {
  .phone_index{
    overflow: auto;
    display: block!important;
  }
  .effect-lists{
    justify-content: flex-start!important;
  }
  .service_chan li {
    margin-right: auto !important;
    margin-bottom: 10px;
    //width: 125px!important;
    height: auto!important;
    overflow: auto;
    background: #fff!important;
    float: left;
  }
  .phone{
    overflow: auto;
    display: none;
  }
}


.strengths {
  display: flex;
  margin-top: 30px;

  li {
    flex: 1;
    text-align: center;
    border-right: 1px solid #eee;
    padding: 0 40px;

    &:last-child {
      border: 0;
    }

    h4 {
      font-size: 18px;
      margin-bottom: 10px;
      color: #014492;
    }
  }
}

.service_chan {
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-between;

  li {
    width: 190px;
    height: 188px;
    //margin-right:60px;
    background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat;
    background-size: auto;

    .img {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    p {
      font-size: 16px;
      color: #4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }

    .liaojie {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color: #959595;
      cursor: pointer;
    }
  }

  li:hover {
    background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat !important;
    background-size: auto !important;

    p {
      color: #fff;
    }

    .liaojie {
      color: #fff;
    }
  }

  li:last-child {
    margin-right: 0;
  }
}

.download {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;

  li {
    width: 50%;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;

    &:nth-of-type(1) {
      border-top: 1px solid #E4E6EA;
    }

    &:nth-of-type(2) {
      border-top: 1px solid #E4E6EA;
    }

    &:hover {
      color: #014492;
    }
  }

  .btn-primary {
    font-size: 14px;

    span {
      margin-right: 7px;
    }
  }

  .mr41 {
    display: block;
  }

  .mr42 {
    display: none;
  }
}

.table {
  tr {
    td:first-child {
      background: #F6FAFD;
    }
  }
}

.c-title small {
  margin-top: 10px;
}

.compose-type1 {
  padding-bottom: 50px;
  //background: url("../../assets/images/molecular/fuys_bj.png") no-repeat;
  //background-size: 100% 100%;
}

.required {
  background: none !important;
  margin-left: 0 !important;
  margin-top: 80px;
}

.desc {
  font-size: 16px;
}

.effect-lists {
  //display: block!important;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: auto;
}
.cons{
  display: none;
}

.effect-lists li {
  margin-right: 30px;
  float: left;
  width: 18%;
  text-align: center;
  margin-bottom: 30px;
}

.effect-lists li:nth-last-of-type(1), .effect-lists li:nth-last-of-type(2), .effect-lists li:nth-last-of-type(3), .effect-lists li:nth-last-of-type(4), .effect-lists li:nth-last-of-type(5) {
  margin-bottom: 0;
}

.effect-lists li:nth-child(5n) {
  margin-right: 0;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap1 wrap-tec1">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="con"> <img src="@/assets/img/产品及服务/常规分子项目/banner.png" class="img-fluid"></div>
      <div class="cons"><img src="@/assets/img/一级标题Banner/常规分子项目banner.jpg" class="img-fluid"></div>
      <div class="info"></div>
    </div>
    <section class="container" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom: 20px;">
        <bread></bread>
      </div>
      <p class="desc" style="margin-bottom: 10px;">
        分子生物学实验是生命科学、医学、制药领域的基础实验项目，应用范围广泛。但影响分子生物学实验的因素因此也复杂多样，结果有时也相对不稳定，耗费科研人员大量精力，影响科研进度。擎科生物拥有专业分子生物学研发设备平台和科研团队，可以为分子生物学相关实验提供一站式解决方案，能够交付给客户精准无误的实验报告，解决科研难题，助力科研服务。
      </p>
      <div class="c-title">项目服务<small>Project services</small></div>
      <div class="container con phone">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer " :class="{active: currentType === index}"
              @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" width="105">
            <p style="margin-top: 10px;">{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <div class="phone_index" style="margin-top: 20px;">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer "  @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px; font-size: 12px">{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{ item.name }}
            <el-button type="primary" class="mr41" icon="el-icon-download"
                       v-if="item.resourceFile.fileType === 'PICTURE'"
                       @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载
            </el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download"
                       v-if="item.resourceFile.fileType === 'PICTURE'"
                       @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载
            </el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>
              下载
            </el-button>
          </li>
        </ul>
      </div>
      <div class="c-title">相关服务与试剂<small>Related services and Reagents</small></div>
      <div class="phone">
        <ul class="service_chan">
          <li v-for="(item, index) in gene1" :key="index" :class="{active: currentService === index}"
              @mouseover="currentService = index" @mouseout="currentService = -1"  @click="$router.push(item.ref)">
            <div class="img">
              <img :src="`/static/img/fenzi1_${index+1}${currentService === index ? '' : '_active'}.png`">
            </div>
            <p>{{ item.name }}</p>
            <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
          </li>
        </ul>
      </div>
      <div class="phone_index" style="margin-top: 20px;">
        <ul class="service_chan">
          <li v-for="(item, index) in gene1" :key="index" :class="{active: currentService === index}"
              @click="$router.push(item.ref)">
            <div class="img">
              <img :src="`/static/img/fenzi1_${index+1}${currentService === index ? '' : '_active'}.png`" style="width: 50px;height: 55px;">
            </div>
            <p>{{ item.name }}</p>
            <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
          </li>
        </ul>
      </div>
      <qk-consult type="Virus"/>
    </section>
  </div>
</template>
<script>
import {resourceColumns, resourceDownloads} from '@/services/api.index'
import bread from "@/components/bread"

export default {
  components: {
    bread
  },
  data() {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'DNA提取', img: '1', ref: '/tec/DNA_extraction'},
        {name: 'PCR扩增', img: '2', ref: '/tec/PCR'},
        {name: '提取+扩增+测序', img: '3', ref: '/products/DNA_tiqu'},
        {name: 'SSR/STR检测', img: '4', ref: '/tec/SSR'},
        {name: 'SNP检测', img: '5', ref: '/tec/SNP'},
        {name: '特定基因检测', img: '6', ref: '/tec/specific'},
        {name: '荧光定量PCR', img: '7', ref: '/tec/qPCR'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
        {name: '细胞系鉴定', img: '9', ref: '/tec/identification'},
        {name: 'T载体克隆', img: '10', ref: '/products/Tvector_cloning'},
        {name: '甲基化检测（BSP测序）', img: '12', ref: '/products/BSP_Sequencing'},
      ],
      gene1: [
        {name: '引物合成', ref: '/tec/compose1'},
        {name: '基因合成', ref: '/tec/gen_compose'},
        {name: '基因检测', ref: '/products/Gene'},
        {name: '基因功能', ref: '/products/Gene_regulation'},
        {name: '病毒包装', ref: '/Virus/Virus_packaging'},
        // {name: '分子试剂', ref: '/equipment/Molecular_reagent'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created() {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns() {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists(id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad(imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile(item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage(value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Conventional_molecular_project.vue